import React, { useContext, useEffect, useState } from "react";
import { Input, Pagination, Table } from "antd";
import { api_call_token } from "../../../../Utils/Network";
import { UserCredsContext } from "../../../../Utils/UserCredsContext";
import moment from "moment";
import EditIcon from "../../../../Assets/ICONS/pen_solid.png";
import { useNavigate } from "react-router-dom";
import styles from "./index.module.css";
import { SearchOutlined } from "@ant-design/icons";

const Rejected = () => {
  const [data, setData] = useState([]);
  const [expandedRowKey, setExpandedRowKey] = useState(null);
  const [filterObj, setFilterObj] = useState({
    page: 1,
    goalApprovedStatus: 2,
  });
  const [currentPage, setCurrentPage] = useState(1);
  const [totalNumberofPage, setTotalNumberofPage] = useState(null);
  let navigate = useNavigate();
  let { logout } = useContext(UserCredsContext);
  const expandedRowRender = (record) => {
    const columns = [
      { title: "KPI Id", dataIndex: "kpiId", key: "kpiId" },
      {
        title: "KPI Target", dataIndex: "kpiTarget", key: "kpiTarget",
        render: (_, record) => {
          const num = _;
          const roundedNum = parseFloat(num.toFixed(2));
          return (
            <>
              {roundedNum}
            </>
          )
        }
      },
      { title: "KPI Achievement", dataIndex: "kpiTargetAchievement", key: "kpiTargetAchievement" },
      { title: "Priority Name", dataIndex: "priorityName", key: "priorityName" },
      { title: "UOM Name", dataIndex: "uomName", key: "uomName" },
      { title: "Start Date", dataIndex: "kpiStartDate", key: "kpiStartDate", render: (_) => {
        return <div>{moment(_).format("DD-MMMM-YYYY")}</div>;
      }, },
      { title: "Due Date", dataIndex: "kpiDueDate", key: "kpiDueDate", render: (_) => {
        return <div>{moment(_).format("DD-MMMM-YYYY")}</div>;
      }, },
      // Add more columns as needed
    ];

    const data = record.goalKpiList.map((kpi) => ({
      key: kpi.kpiId,
      kpiId: kpi.kpiId,
      kpiTarget: kpi.kpiTarget,
      kpiTargetAchievement: kpi.kpiTargetAchievement,
      priorityName: kpi.priorityName,
      uomName: kpi.uomName,
      kpiStartDate: kpi.kpiStartDate,
      kpiDueDate: kpi.kpiDueDate,
      // Map other properties accordingly
    }));

    return <Table columns={columns} dataSource={data} pagination={false} />;
  };

  useEffect(() => {
    getGoals();
  }, [filterObj]);

  const redirectTo = (para) => {
    console.log(para);
    navigate(`approvegoal`, { state: para });
  };

  const getGoals = (paramObj = { ...filterObj }) => {
    api_call_token
    .get(`goal`, { params: { ...paramObj } })
      .then((res) => {
        if (res.status == 200 || res.status == 201 || res.status == 204) {
          setData(res.data.data);
          setCurrentPage(res.data.currentPage);
          setTotalNumberofPage(res.data.totalRowCount)
        } else if (res.status == 401) {
          logout();
        }
      })
      .catch((err) => console.log(err));
  };

  const columns = [
    { title: "Id", dataIndex: "goalId", key: "goalId" },
    { title: "Goal Unique Id", dataIndex: "goalUniqueId", key: "goalUniqueId" },
    { title: "Name", dataIndex: "goalName", key: "goalName" },
    { title: "Goal Category", dataIndex: "goalCategory", key: "goalCategory" },
    { title: "Goal Type", dataIndex: "goalType", key: "goalType" },
    {
      title: "Start Date",
      dataIndex: "goalStartDate",
      key: "goalStartDate",
      render: (_) => {
        return <div>{moment(_).format("DD-MMMM-YYYY")}</div>;
      },
    },
    {
      title: "End Date",
      dataIndex: "goalEndDate",
      key: "goalEndDate",
      render: (_) => {
        return <div>{moment(_).format("DD-MMMM-YYYY")}</div>;
      },
    },
    {
      title: "Department",
      dataIndex: "departmentName",
      key: "departmentName",
      render: (_) => 
        <>{_ ? <div style={{ border: '1px solid grey', fontSize: '12px', padding: '3px 7px', borderRadius: '5px', marginBottom: '5px' }}>{_}</div> : "" }</>
      // <div>{(_ && _.length > 0) ? _.map((vals,i) => <div style={{border: '1px solid grey',fontSize: '12px', padding: '3px 7px',borderRadius: '5px' ,marginBottom: '5px'}}>{vals?.departmentName}</div>) : ""}</div>,
    },
    {
      title: "Assigned User with Read Permission",
      dataIndex: "userList",
      key: "userList",
      render: (_) => <div>{(_ && _.length > 0) ? _.map((vals, i) => <div style={{ border: '1px solid grey', fontSize: '12px', padding: '3px 7px', borderRadius: '5px', marginBottom: '5px' }}>{vals?.fullName}</div>) : ""}</div>,
    },
    {
      title: "Assigned User with Write Permission",
      dataIndex: "permissionUserList",
      key: "permissionUserList",
      render: (_) => <div>{(_ && _.length > 0) ? _.map((vals, i) => <div style={{ border: '1px solid grey', fontSize: '12px', padding: '3px 7px', borderRadius: '5px', marginBottom: '5px' }}>{vals?.fullName}</div>) : ""}</div>,
    },
    {
      title: "Approval Status",
      dataIndex: "goalApprovedStatus",
      key: "goalApprovedStatus",
      render: (_) => {
        return (
          <div
            className={`${styles.category} ${
              _ == 0
                ? styles.pending
                : _ == 1
                ? styles.approved
                : styles.cancelled
            }`}
          >
            {_ == 0 ? "Pending" : _ == 1 ? "Approved" : "Rejected"}
          </div>
        );
      },
    },
    {
      title: "Action",
      dataIndex: "",
      render: (_, record) => {
        // const { purchaseOrderID } = record;
        const handleViewClick = () => {
          redirectTo(record);
        };
        return (
          <div>
            <div
              onClick={handleViewClick}
              style={{ width: "max-content", cursor: "pointer" }}
            >
              <img src={EditIcon} alt="consignment" />
            </div>
          </div>
        );
      },
    },
  ];


  const handlePageChange = (page) => {
    console.log(page, "aaaaaaaaa");
    setFilterObj({ ...filterObj, page: page });
    setCurrentPage(page);
  };

  

  const handleRowClick = (record) => {
    setExpandedRowKey((prevKey) =>
      prevKey === record.key ? null : record.key
    );
  };

  const paginationConfig = {
    current: currentPage,
    pageSize: 10, // Number of items per page
    total: totalNumberofPage, // Total number of items
    onChange: handlePageChange,
  };

  const onSearch = (e) => {
    let value = e.target.value;
    let obj = filterObj;
    if (value) { obj.search = value;obj.page = 1; setCurrentPage(1) }
    else delete obj.search;
    setFilterObj({ ...obj });
  }

  return (
    <div className={styles.mainData}>
      <div className={styles.inputData}>
        <Input
          placeholder="Search by Goal, Goal Category"
          prefix={<SearchOutlined />}
          style={{ width: "100%" }}
          onChange={(e) => onSearch(e)}
        />
      </div>
      <Table
        columns={columns}
        pagination={false}
        expandable={{
          expandedRowRender,
          expandedRowKeys: [expandedRowKey],
          onExpand: (_, record) => handleRowClick(record),
          expandIcon: ({ expanded, onExpand, record }) => (
            <span onClick={() => handleRowClick(record)}>
              {expanded ? "-" : "+"}
            </span>
          ),
        }}
        dataSource={data.map((item, index) => ({
          ...item,
          key: index,
        }))}
      />

      <div style={{ textAlign: "right", margin: "10px" }}>
        <Pagination {...paginationConfig} showSizeChanger={false}/>
      </div>
    </div>
  );
};

export default Rejected;
